import * as React from 'react'
import { Container } from 'components/Layout'
import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import { ContactImport } from 'features/Contacts/ContactImport'
import * as sMarg from 'styles/modules/margins.scss'

export interface IContactImportModalProps {
  modalCancel: () => undefined
}

export class ContactImportModal extends React.Component<IContactImportModalProps> {
  render() {
    const { modalCancel } = this.props
    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center, sMarg.mb30)}>Import Contacts:</div>
          <ContactImport onAfterSubmit={modalCancel} />
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// src/features/Contacts/ContactImportModal/ContactImportModal.tsx